import React from 'react'
import ReactModal from 'react-modal'
import Link from 'gatsby-link'
import styles from './index.module.css'
import './index.css'

export default class Footer extends React.Component {
  constructor() {
    super()
    this.state = {
      showModal: false
    }
    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
  }

  handleOpenModal() {
    this.setState({ showModal: true })
  }

  handleCloseModal() {
    this.setState({ showModal: false })
  }

  render() {
    return (
      <div className={styles.wrapper}>
        <nav className={styles.list}>
          <Link
            className={styles.link}
            activeClassName={'menu-active'}
            to="/about/"
            style={{ width: 'fit-content', marginRight: '1rem' }}>
            About
          </Link>
          <Link
            className={styles.link}
            activeClassName={'menu-active'}
            to="/contact/"
            style={{ width: 'fit-content', marginLeft: '1rem' }}>
            Contact
          </Link>
        </nav>
        <small>
          &copy;2019 Holzauge Fotografie -&nbsp;<a onClick={this.handleOpenModal}>
            Datenschutzerklärung
          </a>
        </small>
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel="Datenschutzerklärung"
          ariaHideApp={false}>
          <h4 style={{ textAlign: 'center' }}>Datenschutzerklärung</h4>
          <p>
            Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck der Verarbeitung
            von personenbezogenen Daten dieser Webseite. Im Hinblick auf die verwendeten
            Begrifflichkeiten, wie z.B. „Verarbeitung“ oder „Verantwortlicher“ verweisen wir auf die
            Definitionen im Art. 4 der Datenschutzgrundverordnung (DSGVO).
          </p>
          <p>
            <div>Verantwortlicher Webseite</div>
            <div>Achim Hilker</div>
            <div>Köln</div>
            <div>mail@achimhilker.com</div>
          </p>
          <p>
            <div>Verantwortlicher Inhalt</div>
            <div>Dennis Hundt</div>
            <div>Frechen</div>
            <div>info@holzauge-fotografie.de</div>
          </p>

          <p>
            Generell ist zu sagen, dass Daten allein zur technischen analyse der Webseite gesammelt
            werden und in keinster Weise für andere Zwecke benutzt/korreliert werden.
          </p>

          <h4 style={{ textAlign: 'center' }}>Erhebung von Zugriffsdaten und Logfiles</h4>
          <p>
            - Wir erheben auf Grundlage unserer berechtigten Interessen im Sinne des Art. 6 Abs. 1
            lit. f. DSGVO Daten über jeden Zugriff auf den Server, auf dem sich dieser Dienst
            befindet (sogenannte Serverlogfiles). Zu den Zugriffsdaten gehören Name der abgerufenen
            Webseite, Datei, Datum und Uhrzeit des Abrufs, übertragene Datenmenge, Meldung über
            erfolgreichen Abruf, Browsertyp nebst Version, das Betriebssystem des Nutzers, Referrer
            URL (die zuvor besuchte Seite), IP-Adresse und der anfragende Provider.
          </p>

          <p>
            - Logfile-Informationen werden aus Sicherheitsgründen (z.B. zur Aufklärung von
            Missbrauchs- oder Betrugshandlungen) für die Dauer von maximal 7 Tagen gespeichert und
            danach gelöscht. Daten, deren weitere Aufbewahrung zu Beweiszwecken erforderlich ist,
            sind bis zur endgültigen Klärung des jeweiligen Vorfalls von der Löschung ausgenommen.
          </p>

          <h4 style={{ textAlign: 'center' }}>Google Universal Analytics</h4>
          <p>
            - Wir setzen Google Analytics in der Ausgestaltung als „Universal-Analytics“ ein.
            „Universal Analytics“ bezeichnet ein Verfahren von Google Analytics, bei dem die
            Nutzeranalyse auf Grundlage einer pseudonymen Nutzer-ID erfolgt und damit ein
            pseudonymes Profil des Nutzers mit Informationen aus der Nutzung verschiedener Geräten
            erstellt wird (sog. „Cross-Device-Tracking“).
          </p>

          <div className="modalclose">
            <a onClick={this.handleCloseModal}>
              <h4>
                <b>Schließen</b>
              </h4>
            </a>
          </div>
        </ReactModal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/index.js